const SettingsRow = ({label, actions}) => (
    <div className='flex items-center justify-between px-4 py-3'>
        <span className='text-sm'>{label}</span>
        <div className='flex items-center gap-2'>
            {actions.map(({text, onClick}) => (
                <span
                    key={text}
                    className='text-xs cursor-pointer rounded-full border border-color-tertiary px-3 py-1 text-color-tertiary transition-all duration-200 active:bg-color-tertiary active:text-white'
                    onClick={onClick}
                >
                    {text}
                </span>
            ))}
        </div>
    </div>
);

export default SettingsRow;
